import { useTraduccion } from '@tallerya/i18n';
import { AvisoError, Boton, CampoTexto, useFormulario, Ventana } from '@tallerya/ui';
import { useCambiosItem, type Categoria } from './datos';

// «Nueva categoría» del Figma (#113): el alta al vuelo desde el combo del
// formulario, con solo el nombre. Sigue a `VentanaMarca.tsx`. Al crearla, el
// formulario la deja elegida (#108).

interface Props {
  abierta: boolean;
  onCerrar: () => void;
  onCreada: (categoria: Pick<Categoria, 'id' | 'name'>) => void;
}

export function VentanaCategoria({ abierta, onCerrar, onCreada }: Props) {
  // La clave reinicia el campo cada vez que se abre.
  return abierta ? <Contenido onCerrar={onCerrar} onCreada={onCreada} /> : null;
}

function Contenido({ onCerrar, onCreada }: Omit<Props, 'abierta'>) {
  const { t } = useTraduccion();
  const cambios = useCambiosItem();

  const form = useFormulario<{ name: string }>({
    inicial: { name: '' },
    validar: (v) => ({ ...(!v.name.trim() && { name: 'validation.required' }) }),
    guardar: async (v) => {
      const { categoria, problema } = await cambios.crearCategoria(v.name);
      if (categoria) onCreada(categoria);
      return problema;
    },
    camposPorCodigo: { 'catalog_category.nombre_duplicado': 'name' },
  });

  async function guardar() {
    if (await form.enviar()) onCerrar();
  }

  return (
    <Ventana
      abierta
      titulo={t('admin.catalogo.categoria.titulo')}
      info={t('admin.catalogo.categoria.descripcion')}
      acciones={
        <>
          <Boton variante="texto" disabled={form.guardando} onClick={onCerrar}>
            {t('admin.catalogo.categoria.cancelar')}
          </Boton>
          <Boton disabled={form.guardando} aria-busy={form.guardando} onClick={() => void guardar()}>
            {t('admin.catalogo.categoria.guardar')}
          </Boton>
        </>
      }
    >
      {form.aviso && <AvisoError aviso={form.aviso} />}
      <CampoTexto
        form={form}
        nombre="name"
        etiqueta={t('admin.catalogo.categoria.nombre')}
        obligatorio
        ancho="completo"
        autoComplete="off"
      />
    </Ventana>
  );
}
